export default __webpack_public_path__ + "static/media/path-of-brew-md.d766de10.png";